module.exports = __webpack_public_path__ + "static/imageClp.fa5d9883.png";